import { gql } from "@apollo/client";

// Queries

export const GET_CLIENTS_BY_NAME = gql`
  query getClientsByName($nombre: String!) {
    getClientsByName(nombre: $nombre) {
      statusCode
      message
      error
      response
    }
  }
`;

export const GET_CLIENTS_BY_ID = gql`
  query getClientsById($id: ID!) {
    getClientsById(id: $id) {
      statusCode
      message
      error
      response
    }
  }
`;

export const GET_ALL_CLIENTS = gql`
  query getAllClients {
    getAllClients {
      statusCode
      message
      error
      response
    }
  }
`;

// Mutations

export const CREATE_CLIENT = gql`
  mutation createClient($nombre: String!) {
    createClient(nombre: $nombre) {
      statusCode
      message
      error
      response
    }
  }
`;
